import { useLocale } from "../../../../hooks/useLocale";
import { msg } from "../../../../locales/translate";
import { Box, VBox } from "@ui/box/Box";
import { Select } from "@ui/select/Select";
import { Typo } from "@ui/text/Typo";
import { ITheme } from "@ui/theme/GlobalTheme";
import { useEffect, useState } from "react";
import { GD } from "src/GD";
import { useTheme } from "styled-components";

interface IMerchantGroupSelectorProps {
	merchant: IMerchantModel;
	clientID: number;
	disabled?: boolean;
}

export const MerchantGroupSelector = ({
	clientID,
	merchant,
	disabled,
}: IMerchantGroupSelectorProps) => {
	useLocale();
	const theme = useTheme() as ITheme;

	const [groups] = GD.B_GROUPS.use({ clientID: clientID });
	const [selected, setSelected] = useState<IClientGroup | undefined>();

	useEffect(() => {
		if (groups?.data && merchant !== null) {
			const selectedGroup = groups.data.find(
				g => g.id === merchant.group_id
			);
			if (selectedGroup) {
				setSelected(selectedGroup);
			}
		}
	}, [groups]);

	const onChange = async (m: IClientGroup) => {
		merchant.group_id = m.id;
	};

	return (
		<Box
			sx={{
				alignItems: "center",
				borderRadius: "8px",
				display: "flex",
			}}>
			{groups?.data && (
				<VBox gap="3px">
					<Typo variant="caption" sx={{ display: "inline" }}>{msg("setChannelWebsite")}</Typo>
					<Select
						disabled={disabled}
						sx={{
							boxShadow: "none",
							border: `1px solid ${theme.colors.divider}`,
							gap: "20px",
							minWidth: "250px",
							borderRadius: "12px",
							height: "40px",
						}}
						sheetAlign="left"
						onChange={e => {
							onChange(e);
						}}
						value={selected}
						values={groups.data}
						// item={<MonthSelectorItem prompt />}
					/>
				</VBox>
			)}
		</Box>
	);
};
